<app-metrics-interactive
  *ngIf="teamID !== 9"
  [teamID]="teamID"
  [clientCode]="clientCode"
></app-metrics-interactive>
<app-metrics-performance *ngIf="teamID === 9"></app-metrics-performance>
